module.exports = "6c595e9a902ef622e42ea82390cfb546.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/flags/korea.png
// module id = 88
// module chunks = 0